import { useEffect, useMemo, useState } from "react";
import { Container, Card, InputGroup, Form, Spinner, Alert, Button, Modal } from "react-bootstrap";

import { useTitle } from "./context";
import { SpellBookBackend } from "./backend";


export function ProfilePage({navbarHeight}) {
    const { setTitle } = useTitle();
    const [username, setUsername] = useState("");
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    
    useEffect(() => {
        setTitle(`Profilo ${username}`);
    }, [setTitle, username]);

    const fetchData = async () => {
        setUsername(await SpellBookBackend.getSessionUsername());
    }
    
    useEffect(() => {
        let mounted = true;
        (
            async () => {
                try {
                    setStatus("loading");
                    await fetchData();
                    if (mounted) {
                        setStatus("success");
                    }
                }
                catch {
                    if (mounted) {
                        setError("Failed to load items.");
                        setStatus("error");
                    }
                }
            }
        )();
        return () => {
            mounted = false;
        };
    }, []);

    const openChangePasswordModal = (e) => {
        setError("");
        setSuccess("");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setShowChangePasswordModal(true);
    };
    
    const closeChangePasswordModal = () => {
        setShowChangePasswordModal(false);
    }
    
    const onChangePasswordSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        // Basic client-side checks
        if (!currentPassword || !newPassword || !confirmPassword) {
            setError("Please fill out all fields.");
            return;
        }
        if (newPassword !== confirmPassword) {
            setError("New password and confirmation do not match.");
            return;
        }
        if (newPassword.length < 5) {
            setError("New password must be at least 5 characters.");
            return;
        }

        try {
            setSubmitting(true);
            await SpellBookBackend.changePassword(username, currentPassword, newPassword);
            setSuccess("Password cambiata con successo.");
            setSubmitting(false);
            closeChangePasswordModal();
        }
        catch (err) {
            setSubmitting(false);
            setError(err?.message || "Failed to change password. Please try again.");
        }
    };

    const content = (
            <Container fluid className="bg-light pt-3 pb-3">
                <Card className="shadow-sm">
                    <Card.Body className="d-flex">
                        <Button variant="primary" onClick={openChangePasswordModal}>
                            Cambia Password
                        </Button>
                    </Card.Body>
                </Card>
                
                {success && <Alert variant="success">{success}</Alert>}

                <Modal show={showChangePasswordModal} onHide={closeChangePasswordModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Cambio Password</Modal.Title>
                    </Modal.Header>

                    <Form onSubmit={onChangePasswordSubmit}>
                        <Modal.Body>
                            {error && <Alert variant="danger">{error}</Alert>}

                            <Form.Group className="mb-3" controlId="currentPassword">
                                <Form.Label>Password corrente</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                    type="password"
                                    placeholder="Password corrente"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    autoComplete="current-password"
                                    required
                                    />
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="newPassword">
                            <Form.Label>Password nuova</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                    type="password"
                                    placeholder="Password nuova"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    autoComplete="new-password"
                                    required
                                    />
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="confirmPassword">
                                <Form.Label>Confema password nuova</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                    type="password"
                                    placeholder="Password nuova"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    autoComplete="new-password"
                                    required
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={closeChangePasswordModal} disabled={submitting}>
                                Annulla
                            </Button>
                            <Button type="submit" variant="primary" disabled={submitting}>
                            {submitting ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                        Cambio password in corso...
                                </>
                            ) : (
                                "Conferma"
                            )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </Container>
    );

    const containerMargin = `${navbarHeight}px`;
    const containerHeight = `calc(100vh - ${navbarHeight}px)`;
    
    return (
        <Container
        fluid
        className="bg-light p-0"
        style={{
            marginTop: containerMargin,
            height: containerHeight,
            overflowY: "auto"
        }}
        >
            {content}
        </Container>);
}
